import { PortfolioAbout, PortfolioHome, PortfolioProjects } from '@/components/portfolio';
import React from 'react';

// Mobile-specific portfolio components that import directly
export const MobilePortfolioHome: React.FC = () => {
    return <PortfolioHome isMobile={true} />;
};

export const MobilePortfolioAbout: React.FC = () => {
    return <PortfolioAbout isMobile={true} />;
};

export const MobilePortfolioProjects: React.FC = () => {
    return <PortfolioProjects isMobile={true} />;
};
